import { Component, Inject, OnInit } from '@angular/core';
import { AppService, DentalBidirectionalList, DentalBidirectionalListItem, SaveDentalBidirectionalListItemRequest } from '../../../app.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from '../../../common/loading.service';
import { AlertService } from '../../../common/alert.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-list-item-edit-dialog',
  templateUrl: './list-item-edit-dialog.component.html',
  styleUrl: './list-item-edit-dialog.component.scss'
})
export class ListItemEditDialogComponent implements OnInit {

  public list: DentalBidirectionalList = null;
  public listItemToUpdate: DentalBidirectionalListItem = null;

  public form: FormGroup;
  public listItemNameFormControl: FormControl;
  public listItemDescriptionFormControl: FormControl;
  public listItemOrderFormControl: FormControl;
  public listItemActiveFormControl: FormControl;

  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
    private dialog: MatDialogRef<ListItemEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }



  ngOnInit(): void {
    if (this.data?.List) {
      this.list = this.data.List;
    }
    if (this.data?.ListItemToUpdate) {
      this.listItemToUpdate = this.data.ListItemToUpdate;
    }
    this.initForm();
  }

  private initForm() {
    this.form = new FormGroup({});

    this.listItemNameFormControl = new FormControl('', [Validators.required]);
    this.form.addControl('listItemNameFormControl', this.listItemNameFormControl);

    this.listItemDescriptionFormControl = new FormControl('', [Validators.required]);
    this.form.addControl('listItemDescriptionFormControl', this.listItemDescriptionFormControl);

    this.listItemOrderFormControl = new FormControl();
    this.form.addControl('listItemOrderFormControl', this.listItemOrderFormControl);

    this.listItemActiveFormControl = new FormControl();
    this.form.addControl('listItemActiveFormControl', this.listItemActiveFormControl);

    if (this.listItemToUpdate) {
      this.listItemNameFormControl.setValue(this.listItemToUpdate.name);
      this.listItemDescriptionFormControl.setValue(this.listItemToUpdate.description);
      this.listItemOrderFormControl.setValue(this.listItemToUpdate.order);
      this.listItemActiveFormControl.setValue(this.listItemToUpdate.active);
    }
  }

  public onCancelClick() {
    this.dialog.close(null);
  }

  public onSaveClick() {
    if (this.form.valid) {
      this.spinner.show();

      const listItemToSave = new DentalBidirectionalListItem();
      listItemToSave.listId = this.list.id;
      listItemToSave.id = this.listItemToUpdate?.id;
      listItemToSave.name = this.listItemNameFormControl.value;
      listItemToSave.description = this.listItemDescriptionFormControl.value;
      listItemToSave.order = this.listItemOrderFormControl.value ? this.listItemOrderFormControl.value : 9999;
      listItemToSave.active = this.listItemActiveFormControl.value;

      const request = new SaveDentalBidirectionalListItemRequest();
      request.listItem = listItemToSave;

      this.service.SaveDentalBidirectionalListItem(request)
        .pipe(
          finalize(() => {
            // Hide the spinner after the request completes
            this.spinner.hide();
          })
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.alert.success('Successfully saved list item.');
              this.dialog.close(null);
            } else {
              this.alert.warning(response.message);
            }
          },
          error: (error) => {
            console.error('Error submitting form:', error);
            this.alert.errorWithDetails(error, 'Unable to save list item.');
          }
        });
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
      this.alert.warning('Please correct the errors in the form before submitting.');
    }
  }
}
